export default{
    // 获取作者列表
    'getAuthorList':'/api/find/author/list',
    // 合并学者
    'authorMerge':'/api/merge'
}